export const apnTypeEnum = {
    PUBBLICO: "PUBBLICO",
    CONDIVISO: "CONDIVISO",
    DEDICATO: "DEDICATO",
    SICUREZZA_CENTRALIZZATA: "SICUREZZA_CENTRALIZZATA",
}

export const disableConfirmBtn = (inputForm) => {
    if (inputForm.apnType === apnTypeEnum.PUBBLICO)
        return false

    if (inputForm.apnType === apnTypeEnum.SICUREZZA_CENTRALIZZATA)
        return !inputForm.apnName

    if (inputForm.apnType === apnTypeEnum.CONDIVISO)
        return !inputForm.apnName || !inputForm.vrfName

    if (inputForm.apnType === apnTypeEnum.DEDICATO)
        return !inputForm.apnName

    return true
}

export const DEFAULT_APN_NAME = "vpn.fastweb.it"
